import angular from 'angular';

export default function stickyScroll($compile, $window) {
  'ngInject';

  return {
    compile() {
      return {
        post($scope, $element) {
          let cloneShown;
          const tbodyElement = $element.find('tbody');
          const scrollElement = angular.element(`
            <div class="sticky-scrollbar-container">
              <div class="sticky-scrollbar" ng-style="stickyScrollbarStyle">
              </div>
            </div>
          `);

          $scope.stickyScrollbarStyle = {
            width: '0',
          };

          $element.prepend(scrollElement);
          $compile(scrollElement)($scope);

          $element.on('scroll', () => translateScroll($element, scrollElement));
          scrollElement.on('scroll', () => translateScroll(scrollElement, $element));
          refresh();
          angular.element($window).on('scroll', refresh);
          $scope.$on('$destroy', () => {
            scrollElement.remove();
            angular.element($window).off('scroll', refresh);
          });

          function translateScroll(fromElement, toElement) {
            toElement[0].scrollLeft = fromElement[0].scrollLeft;
            toElement[0].scrollTop = fromElement[0].scrollTop;
          }

          function refresh() {
            $scope.stickyScrollbarStyle.width = `${tbodyElement[0].clientWidth}px`;
            const previouslyShown = cloneShown;
            const originalElementRect = $element.find('table')[0].getBoundingClientRect();

            cloneShown = originalElementRect.bottom - $window.innerHeight > 0;
            if (cloneShown !== previouslyShown) {
              scrollElement[cloneShown ? 'removeClass' : 'addClass']('ng-hide');

              if (cloneShown) {
                translateScroll($element, scrollElement);
              }
            }
          }
        },
      };
    },
  };
}
